import { animate, style, transition, trigger } from "@angular/animations";
import { Component, OnInit } from "@angular/core";
import { Subscription } from "rxjs";
import { KwikUILoaderService } from "./loader.service";

@Component({
  selector: "kwikui-loader",
  templateUrl: "./loader.component.html",
  styleUrls: ["./loader.component.scss"],
  animations: [
    trigger("panelInOut", [
      transition(":enter", [
        style({ transform: "translateY(100%)" }),
        animate(150)
      ]),
      transition(":leave", [
        animate(100, style({ transform: "translateY(100%)" }))
      ])
    ])
  ]
})
export class KwikUILoaderComponent implements OnInit {
  isLoaderVisible = false;

  private loaderSubscription: Subscription;

  constructor(public loaderService: KwikUILoaderService) {
    // Subscribe to the loaderService's changes in showLoader
    this.loaderSubscription = this.loaderService.showLoader.subscribe(
      (isVisible) => {
        this.isLoaderVisible = isVisible; // Update the component property
      }
    );
  }

  ngOnInit(): void {}

  ngOnDestroy(): void {
    // Unsubscribe from the observable to avoid memory leaks
    this.loaderSubscription.unsubscribe();
  }
}
